import { StretchPopup } from './stretchPopup';
import { CurrentPage } from '../pages/currentPage';
import { ErrorToolTip, TooltipDirection } from '../general/newErrorToolTip';
import { LandingEmailRegistration } from '../user/landingEmailRegistration';
import { Localization } from '../localization/localization';
import { setupPassStrengthWidgetListenerFbEmail } from '../view/password-strength-widget';
import { FingerprintjsWrapper } from '../general/modules/fingerprintjs/FingerprintjsWrapper';
import { GtmSender } from '../marketing/GtmSender';
import { SystemEvents } from '../constants/gameEvents';
import { CheckboxValue, RegistrationProtocol } from '../user/registrationProtocol';
import { checkEmailAvailable } from './emailChecker';

export class RegFbEmailPopup {
    private sendingInProgress: boolean = false;
    private popup: JQuery;

    private constructor($regForm: JQuery) {
        this.popup = $regForm;

        const $fbLoginButton = $regForm.find('.b-fb-rect');
        const $emailRegButton = $regForm.find('.b-email-rect');

        // @ts-ignore
        $fbLoginButton.on('click', window.app.fb_login);
        $emailRegButton.on('click', () => {
            $regForm.find('.registration-fb-email__email-reg').show();
            StretchPopup.stretch();
        });

        $regForm.find('.registration-fb-email__to-step-2').on('click', this.onNextButtonClick);
        $regForm.find('.registration-fb-email__reg').on('click', this.onRegButtonClick);
        setupPassStrengthWidgetListenerFbEmail();
    }


    public static setup() {
        const $regForm = $('.registration-fb-email');
        $regForm.each(function initRegFbEmailHandlers() {
            new RegFbEmailPopup($(this));
        });
    }

    private getCsrfToken(): string {
        return $('[name="csrftoken"]').val() as string;
    }

    private onNextButtonClick = () => {
        if (this.sendingInProgress) {
            return;
        }

        this.sendingInProgress = true;

        const emailField = this.popup.find('input[type=email]');
        const tooltip = ErrorToolTip.getTooltipElement();

        checkEmailAvailable(emailField, tooltip).then((result: boolean) => {
            this.sendingInProgress = false;
            if (result) {
                this.popup.find('.error').removeClass('error');
                $('.registration-fb-email__step-1').hide();
                $('.registration-fb-email__step-2').show();
                StretchPopup.stretch();
            }
        });
    };

    private onRegButtonClick = () => {
        if (this.sendingInProgress === true) {
            return;
        }

        const tooltip = ErrorToolTip.getTooltipElement();
        const termsChbx = this.popup.find('.js-terms_agree');
        if (!termsChbx.hasClass('checked')) {
            tooltip.showTooltipElement(
                termsChbx,
                TooltipDirection.LEFT,
                Localization._n('agree_error')
            );
            return;
        }

        this.sendingInProgress = true;
        this.register()
            .catch(() => {
                this.sendingInProgress = false;
            });
    };

    private async register() {
        const confidenceScore = await FingerprintjsWrapper.getConfidenceScore();
        const emailField = this.popup.find('input[type=email]');
        const email: string = (emailField.val() as string).trim();
        const passwordField = this.popup.find('input[type=password]');
        const password: string = (passwordField.val() as string).trim();
        const state = $('.registration-fb-email [name=state]').val();
        const tooltip = ErrorToolTip.getTooltipElement();

        const regData: RegistrationProtocol = {
            'confidence': confidenceScore,
            'csrftoken': this.getCsrfToken(),
            email,
            'lp': 1,
            password,
            'receive_consent': 'off' as CheckboxValue,
            state
        };
        CurrentPage.setLoadingState();
        const [isSuccess, error] = await LandingEmailRegistration.register(regData);
        CurrentPage.disableLoadingState();
        if (isSuccess) {
            GtmSender.fireMarketing(SystemEvents.REGISTRATION);
            CurrentPage.reload();
        } else {
            this.sendingInProgress = false;
            tooltip.showTooltipElement($('.registration-fb-email__reg'), TooltipDirection.UP, error.message);
        }
    }
}
